export default {
    auth: {
        login: {
            buttons: {
                enter: '进入',
                otherStudent: '以其他学生身份进入',
                otherClassroom: '进入其他班级',
                pwa: '创建快捷方式',
            },
            pwa: {
                title: '想在主屏幕上创建类似应用的快捷方式吗？',
                description: '之后无需班级代码即可直接进入！',
                install: {
                    ios: '点击 Safari 浏览器底部的"共享"按钮，然后选择"添加到主屏幕"。',
                    android: '点击浏览器菜单(⋮)，然后选择"安装应用"。',
                    default: '在浏览器菜单中选择"添加到主屏幕"或"安装应用"。',
                },
                buttons: {
                    next: '下次再说',
                    create: '创建快捷方式',
                },
            },
            pinSet: 'PIN 码已设置！请进入课堂。',
            stepClassroom: {
                title: '学生进入',
                description: '请输入老师分享的班级代码！',
            },
            stepPin: {
                studentInfo: '{number}号 {name}',
                input: '请输入 PIN 码以进入课堂。',
                set: '请设置 PIN 码以进入课堂。',
                retry: '请再次输入 PIN 码。',
                tip: '进入课堂时需要 PIN 码，请务必记住！',
                error: {
                    confirm: 'PIN 码不一致！请确认后重新输入。',
                    unknown: '发生未知错误。',
                    pin: '无法验证 PIN 码。',
                    set: '无法设置 PIN 码。',
                },
            },
            stepStudent: {
                title: '请输入出勤号和姓名！',
                placeholder: {
                    number: '请输入出勤号（数字）',
                    name: '请输入姓名（韩文）',
                },
                error: {
                    nameKorean: '只能输入韩文。',
                    number: '只能输入数字。',
                    unknown: '发生未知错误。',
                },
            },
        },
    },
};
